<template>
    <!--新增资源-关联数据弹窗-->
    <el-dialog title="关联数据" :fullscreen="true" append-to-body :close-on-click-modal="false" :visible.sync="visible">
        <el-row :gutter="4" class="h100 configurationList">
            <el-col :span="showList ? 4 : 1" :class="['p_r h100i', showList ? '' : 'el-col-unfold']"
                    v-loading="showList && treeLoading">
                <div :class="['unfoldClassifyBtn', showList ? 'el-icon-arrow-left':'el-icon-arrow-right']"
                     @click="showList = !showList"></div>
                <el-menu class="h100 metadataTree" :default-active="searchForm.basicDataId" @select="selectMenu">
                    <el-menu-item :index="item.basicDataId" v-for="item in basicDataList" :key="item.basicDataId">
                        <span slot="title">{{item.basicDataName}}</span>
                    </el-menu-item>
                </el-menu>
            </el-col>
            <el-col :span="showList ? 20 : 24" :class="['h100', showList ? '' : 'el-col-unfold']">
                <div class="el-table-container">
                    <el-form size="small" class="query-form" ref="form" :model="form"
                             label-width="140px" @keyup.enter.native="refreshList(1)">
                        <div class="dynamicForm">
                            <el-form-item prop="keyword" label="输入搜索：">
                                <el-input v-model.trim="searchForm.keyword" maxlength="100"
                                          placeholder="关键字搜索"
                                          clearable></el-input>
                            </el-form-item>
                            <el-form-item :label="item.basicRename + '：'" :prop="item.basicCode"
                                          v-for="(item, index) in basicDataInfo.whereList" :key="index"
                                          v-if="item.disabled == '0'">
                                <!--单选、多选、开关-->
                                <el-select class="w100i" v-model="form[item.basicCode]"
                                           :multiple="item.basicAssemblyId == 6 || item.basicAssemblyId == 7"
                                           placeholder="请选择" clearable
                                           v-if="item.basicAssemblyId == 4 || item.basicAssemblyId == 5 || item.basicAssemblyId == 6 || item.basicAssemblyId == 7 || item.basicAssemblyId == 10">
                                    <el-option v-for="(v,i) in item.basicRangeList" :key="i"
                                               :label="v.basicRange"
                                               :value="v.basicRange"></el-option>
                                </el-select>
                                <!--日期-->
                                <el-date-picker class="w100i"
                                                v-model="form[item.basicCode]" value-format="yyyy-MM-dd HH:mm:ss"
                                                :format="item.metadataBasicDataRuleVo ? item.metadataBasicDataRuleVo.ruleDateFormat : 'yyyy-MM-dd HH:mm:ss'"
                                                :type="setDatePickerType(item, 1)"
                                                clearable start-placeholder="开始时间"
                                                end-placeholder="结束时间"
                                                v-else-if="item.basicAssemblyId == 9">
                                </el-date-picker>
                                <!--时间-->
                                <el-time-picker class="w100i" v-model="form[item.basicCode]"
                                                value-format="yyyy-MM-dd HH:mm:ss" format="HH:mm:ss"
                                                is-range range-separator="至" start-placeholder="开始时间"
                                                end-placeholder="结束时间"
                                                v-else-if="item.basicAssemblyId == 8"></el-time-picker>
                                <el-input v-model.trim="form[item.basicCode]" maxlength="100" placeholder="请输入"
                                          clearable
                                          v-else></el-input>
                            </el-form-item>
                        </div>
                        <div class="p_b04">
                            <el-button type="primary" icon="el-icon-search" @click="refreshList(1)" size="small">查询
                            </el-button>
                            <el-button type="primary" icon="el-icon-search" @click="refreshList(1, 2)" size="small">
                                结果中查询
                            </el-button>
                            <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
                        </div>
                    </el-form>
                    <div class="tips">
                        <el-link class="el-icon-info" type="primary" :underline="false"></el-link>
                        已选择{{dataListSelections.length}}项数据
                    </div>
                    <el-table
                            :data="dataList"
                            size="small" height="100%"
                            class="table" ref="multipleTable" border
                            @selection-change="selectionChangeHandle" @sort-change="sortChange" row-key='id'
                            v-loading="loading">
                        <el-table-column type="selection" :reserve-selection='true' fixed
                                         :selectable="checkSelectable"/>
                        <el-table-column v-for="(item, index) in basicDataInfo.tableList" :key="index"
                                         :prop="item.basicCode"
                                         :label="item.basicRename"
                                         :sortable="item.basicAssemblyId == '8' || item.basicAssemblyId == '9' || item.basicAssemblyId == '12' ? 'custom' : false"
                                         show-overflow-tooltip v-if="item.disabled == '0'" min-width="100">
                            <template slot-scope="scope">
                                <span>{{listDataFormat(item, scope.row.jsonData[item.basicCode])}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                                @pagination="refreshList"/>
                </div>
            </el-col>
        </el-row>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="confirm()" v-noMoreClick>确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                treeLoading: false,
                showList: true,
                basicDataList: [],
                form: {},
                searchForm: {
                    keyword: '',
                    basicDataId: '',
                    ruleId: '',
                    current: 1,
                    size: 20,
                    whereList: [],
                    sortArchivesDataElasticsearch: [],
                    metadataTableConfigId: '',
                },
                basicDataInfo: {},
                loading: false,
                dataList: [],
                dataListSelections: [],
                total: 0,
                maxNum: 0,
                itemInfo: {},
                selectedId: [], //关联数据已选数据
            }
        },
        methods: {
            init(item, selectedId) {
                this.selectedId = selectedId || []
                this.searchForm.metadataTableConfigId = item.metadataBasicDataRuleVo.associationBasicDataId
                this.itemInfo = item
                this.form = {}
                this.searchForm.keyword = ''
                this.searchForm.whereList = []
                this.searchForm.ruleId = item.metadataBasicDataRuleVo.id
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.multipleTable.clearSelection()
                    this.getMaxNum()
                    this.getField()
                })
            },
            // 获取数据列表 current: 1第一页；searchType：2结果中查询，3高级查询
            refreshList(current, searchType) {
                if (current == 1) {
                    this.searchForm.current = 1
                }
                this.loading = true
                if (!searchType) {
                    this.searchForm.whereList = []
                }
                if (searchType != 3) {
                    let keys = Object.keys(this.form)
                    let values = Object.values(this.form)
                    keys.map((key, index) => {
                        let item = this.basicDataInfo.whereList.filter(v => v.basicCode == key)[0]
                        if ((item.basicAssemblyId == '6' || item.basicAssemblyId == '7') && Array.isArray(values[index]) && values[index].length) {
                            values[index].map(v => {
                                this.returnWhere(v, 'and', item.basicCode, '%', item.assemblyType)
                            })
                        } else if ((item.basicAssemblyId == 8 || item.basicAssemblyId == 9) && Array.isArray(values[index]) && values[index].length) {
                            this.returnWhere(values[index][0], 'and', item.basicCode, '>=', item.assemblyType)
                            this.returnWhere(values[index][1], 'and', item.basicCode, '<=', item.assemblyType)
                        } else if (!Array.isArray(values[index]) && values[index]) {
                            this.returnWhere(values[index], 'and', item.basicCode, '%', item.assemblyType)
                        }
                    })
                }
                this.$axios(this.api.metadata.queryElasticsearchTemplatePage, this.searchForm, 'post').then(data => {
                    if (data.status) {
                        this.dataList = data.data.records
                        if (this.dataList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.refreshList()
                        }
                        this.total = parseInt(data.data.total)
                        this.$nextTick(() => {
                            this.selectedId.map(v => {
                                this.dataList.map(item => {
                                    if (v == item.id) {
                                        this.$set(item, 'checked', true)
                                    }
                                })
                            })
                        })
                        this.loading = false
                    } else {
                        this.$message.error('查询失败');
                    }
                })
            },
            returnWhere(value, method, key, basicTypeMethodCode, assemblyType) {
                let flag = this.searchForm.whereList.filter(item => item.key == key && item.value == value).length
                if (!flag) {
                    this.searchForm.whereList.push({value, method, key, basicTypeMethodCode, assemblyType})
                }
            },
            // 获取字段
            getField(basicDataId) {
                this.treeLoading = true
                this.$axios(this.api.metadata.metadatatableconfigGetById + '?configId=' + this.searchForm.metadataTableConfigId + '&metadataFonctionsModelId=', [], 'post').then(data => {
                    if (data.status) {
                        this.basicDataList = data.data.basicDataIdList
                        this.searchForm.size = parseInt(data.data.defautNombre)
                        this.$nextTick(() => {
                            this.selectMenu(basicDataId || this.basicDataList[0].basicDataId)
                        })
                    } else {
                        this.$message.error('查询失败')
                    }
                    this.treeLoading = false
                })
            },
            // 选择树节点
            selectMenu(val) {
                this.searchForm.whereList = []
                this.searchForm.sortArchivesDataElasticsearch = []
                this.searchForm.basicDataId = val
                this.basicDataInfo = this.basicDataList.filter(item => item.basicDataId == val)[0]
                this.form = {}
                this.reset(1)
            },
            // 获取最大关联数量
            getMaxNum() {
                this.$axios(this.api.user.configKey + '/assembly_max_size').then(data => {
                    if (data.status) {
                        this.maxNum = parseInt(data.data)
                    }
                })
            },
            checkSelectable(row) {
                return !row.checked
            },
            // 确定
            confirm() {
                if (!this.dataListSelections.length) {
                    this.$message.warning('请选择关联数据')
                    return
                }
                if (this.dataListSelections.length > this.maxNum) {
                    this.$message.warning('关联数据选择数量不能超过' + this.maxNum + '条')
                    return
                }
                this.loading = true
                this.$axios(this.api.metadata.groupByTemplate + "?configId=" + this.searchForm.metadataTableConfigId, this.dataListSelections, 'post').then(data => {
                    if (data.status) {
                        this.visible = false
                        this.$emit('refreshAssociatedData', {
                            basicDataIdList: data.data.basicDataIdList,
                            itemInfo: this.itemInfo,
                            selId: this.dataListSelections
                        })
                    } else {
                        this.$message.error('操作失败');
                    }
                    this.loading = false
                })
            },
            // 列表排序
            sortChange(column) {
                let item = this.basicDataInfo.whereList.filter(v => v.basicCode == column.prop)[0]
                this.searchForm.sortArchivesDataElasticsearch = [
                    {
                        assemblyType: item.assemblyType,
                        key: column.prop,
                        sort: column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : ''),
                    }
                ]
                this.refreshList()
            },
            // 多选
            selectionChangeHandle(val) {
                let ids = val.map(item => {
                    return item.id
                })
                this.dataListSelections = this.selectedId.concat(ids)
            },
            // 重置
            reset(type) {
                this.searchForm.keyword = ''
                this.searchForm.whereList = []
                if (!type) {
                    this.$refs.multipleTable.clearSelection()
                }
                this.form = {}
                this.basicDataInfo.whereList.map(item => {
                    if (item.disabled == '0') {
                        if (item.basicAssemblyId == '6' || item.basicAssemblyId == '7') {
                            this.$set(this.form, item.basicCode, [])
                        } else {
                            this.$set(this.form, item.basicCode, null)
                        }
                    }
                })
                this.$nextTick(() => {
                    this.refreshList(1, 3)
                })
            },
        }
    }
</script>

<style scoped>

</style>
